import { useQuery } from "@tanstack/react-query";
import type { NavItemLink } from "@wayflyer/flyui";
import { IconSecurityPass20Line } from "@wayflyer/flyui-icons/20/line";
import { getCheckoutQuoteQueryOptions } from "customer-queries/checkout";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useIntl } from "react-intl";

import { CHECKOUT_NAV_ITEM_ID } from "./nav-layout";

const CHECKOUT_HOME_ROLLOUT_FLAG = "enable_checkout_home";

export function useCheckoutNavigationItem({ customerDomain }: { customerDomain: string }): NavItemLink | undefined {
  const intl = useIntl();
  const rolloutEnabled = useFeatureFlagEnabled(CHECKOUT_HOME_ROLLOUT_FLAG);
  const queryEnabled = rolloutEnabled === true && !!customerDomain;
  const { data: quote, isError } = useQuery({
    ...getCheckoutQuoteQueryOptions(customerDomain),
    enabled: queryEnabled,
  });

  if (!queryEnabled || isError || !quote) {
    return;
  }

  return {
    id: CHECKOUT_NAV_ITEM_ID,
    label: intl.formatMessage({
      id: "checkout navigation item",
      defaultMessage: "Checkout",
    }),
    href: `/${customerDomain}/checkout`,
    icon: <IconSecurityPass20Line />,
  };
}
